/* eslint-disable @typescript-eslint/default-param-last */
/* eslint no-param-reassign: ["error", { "props": false }] */
import produce, { Draft } from 'immer';
import { FarmSectorCustomAction, FarmSectorState, SensorNode } from '../types';
import {
  SET_ALL_FARM_DEVICES,
  SET_FARM_DEVICE,
  SET_SENSOR_NODE_FILTER, SET_SENSOR_TYPE, SET_DASHBOARD_TYPE, RESET_FARM_SECTOR_STATE,
} from '../actions/farmSectorActions';
import { SensorModelSchema, NodeSchema } from '../requests/api/apiTypes';

const initialState: FarmSectorState = {
  selectedSector: '',
  selectedDevice: '',
  allFarmDevices: [],
  sensorNodeFilter: {
    deviceType: 'node',
    filterValue: '',
  },
  sensorType: 'clima',
  dashboardType: 1,
};

const farmSectorReducer = (
  state = initialState,
  action: FarmSectorCustomAction,
): FarmSectorState => {
  switch (action.type) {
    case SET_FARM_DEVICE: {
      return produce(state, (draft: Draft<FarmSectorState>) => {
        draft.selectedDevice = action.payload as string;
      });
    }

    case SET_ALL_FARM_DEVICES: {
      return produce(state, (draft: Draft<FarmSectorState>) => {
        draft.allFarmDevices = [...action.payload as Array<NodeSchema | SensorModelSchema>];
      });
    }

    case SET_SENSOR_NODE_FILTER: {
      return produce(state, (draft: Draft<FarmSectorState>) => {
        draft.sensorNodeFilter = action.payload as SensorNode;
      });
    }

    case SET_SENSOR_TYPE: {
      return produce(state, (draft: Draft<FarmSectorState>) => {
        draft.sensorType = action.payload as string;
      });
    }

    case SET_DASHBOARD_TYPE: {
      return produce(state, (draft: Draft<FarmSectorState>) => {
        draft.dashboardType = action.payload as number;
      });
    }

    case RESET_FARM_SECTOR_STATE: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};

export default farmSectorReducer;
